import styled from 'styled-components';

export const MyTask = styled.h1`
  margin: 25px 30px 0px;
  height: 22px;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: normal;
  text-align: left;
  color: #2c2c2c;
  border-radius: 4px;
`;
